module.exports = __webpack_public_path__ + "static/media/toolgauge_small.1f53a0a4.png";